import { Route } from '@angular/router';
import { mediumExplorer } from './medium-explorer';
import { mediumGroups } from './medium-groups';
import { RoutingID } from '../../../sb-routing-enum';
import { contentEditor } from './content-editor';
import { SbIcons } from '@ngx-seatback/icons';
import { assetExplorer } from './asset-explorer';

export const media: Route = {
  path: 'media',
  title: 'nav.motives',
  data: {
    icon: SbIcons.motive,
    breadcrumb: 'nav.motives',
    id: RoutingID.media,
  },
  children: [
    {
      path: '',
      redirectTo: RoutingID.mediumExplorer,
      pathMatch: 'full',
      data: {
        breadcrumb: '',
      },
    },
    mediumExplorer,
    mediumGroups,
    contentEditor,
    assetExplorer,
  ],
};
